
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["footer__social-link-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.59 19.04c.45-.4.75-.92.87-1.5.32-1.83.5-3.68.54-5.54 0-1.86-.19-3.71-.54-5.54a2.75 2.75 0 00-.87-1.5 3.08 3.08 0 00-1.64-.74 66.5 66.5 0 00-17.96 0c-.61.08-1.19.34-1.64.74-.45.4-.75.92-.87 1.5A30.72 30.72 0 000 12c0 1.86.15 3.71.48 5.54.12.58.42 1.1.87 1.5.45.4 1.03.66 1.64.74a66.5 66.5 0 0017.96 0 3.08 3.08 0 001.64-.74zM16.76 12L9.58 8.08v7.84L16.76 12z","fill":"currentColor"}})])
          )
        }
      }
    